var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-button",
    {
      staticClass: "back-button float-left",
      attrs: { variant: "light" },
      on: {
        click: function ($event) {
          return _vm.goBack()
        },
      },
    },
    [_c("b-icon", { attrs: { icon: "arrow-left" } })],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }